const getBooleanTitle = ({
  text, operator, value, label,
}) => {
  const operatorLabels = {
    isSet: `${text} set`,
    notSet: `${text} not set`,
  };

  if (operatorLabels[operator]) return operatorLabels[operator];

  if (label === 'Unchecked' || label === 'Checked') return label;

  return value === 'true' ? `Show ${text.replace(/\bstatus\b/g, '').trim().toLowerCase()}` : `Hide ${text.replace(/\bstatus\b/g, '').trim().toLowerCase()}`;
};

export default getBooleanTitle;
